import React, { useState, useEffect } from "react";
import { Popover, Button, Modal, Input, Avatar, Skeleton } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faHeadset, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserDetailsFromReducer, logout } from "Store/reducers/Auth/AuthSlice";
import { FetchFileFromS3 } from "Utility/Helpers/Storage";
import { Auth } from "aws-amplify";

const ProfileMenu = () => {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [settingsOpen, setSettingsOpen] = useState(false);
  const user = useSelector(getUserDetailsFromReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const name = user?.name || "";

  const [imageURL, setImageURL] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user?.logo) {
      fetchURL(user?.logo);
    } else {
      setImageURL(null);
    }
    // eslint-disable-next-line
  }, [user?.logo]);

  const fetchURL = async (key) => {
    setIsLoading(true);
    try {
      const url = await FetchFileFromS3(key);
      setImageURL(url || null);
    } catch (error) {
      setImageURL(null);
    } finally {
      setIsLoading(false);
    }
  };

  const initials = name
    ? name
        .split(" ")
        .map((n, index) => (index === 0 || index === 1 ? n[0]?.toUpperCase() : ""))
        .join("")
        .slice(0, 2)
    : user?.username
    ? user.username.slice(0, 2).toUpperCase()
    : "U";

  useEffect(() => {
    getAuthenticatedUser();
  }, []);

  const getAuthenticatedUser = async () => {
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      setEmail(cognitoUser.attributes.email || "");
    } catch (error) {
      console.error("Error fetching authenticated user:", error);
    }
  };

  const content = (
    <div className="w-auto flex flex-col gap-1">
      <div className="flex items-center gap-2 px-2 py-1">
        <span className="text-gray-500 text-sm font-medium">{email}</span>
      </div>
      {/* Settings option commented out
      <Button
        type="text"
        className="flex items-cente justify-start gap-2 w-full px-2 py-2 rounded-lg hover:bg-primary-varients-50"
        onClick={() => {
          setVisible(false);
          setSettingsOpen(true);
        }}
      >
        <FontAwesomeIcon icon={faCog} />
        <span className="text-gray-700 text-sm font-medium">Settings</span>
      </Button>
      */}
      <Button
        type="text"
        className="flex items-center justify-start gap-2 w-full px-2 py-2 rounded-lg hover:bg-primary-varients-50"
        onClick={() => {
          setVisible(false);
          navigate("/my-accounts");
        }}
      >
        <FontAwesomeIcon icon={faUserCircle} />
        <span className="text-foreground text-sm font-medium">My Account</span>
      </Button>
      <Button
        variant="ghost"
        className="flex items-center justify-start gap-2 w-full px-2 py-2 rounded-lg hover:bg-primary-varients-50"
        onClick={() => {
          setVisible(false);
          navigate("/contact-support");
        }}
      >
        <FontAwesomeIcon icon={faHeadset} />
        <span className="text-gray-700 text-sm font-medium">Contact Support</span>
      </Button>
      <Button
        type="text"
        className="flex items-center justify-start gap-2 w-full px-2 py-2 rounded-lg hover:bg-red-50"
        onClick={() => {
          setVisible(false);
          dispatch(logout());
        }}
      >
        <FontAwesomeIcon icon={faSignOutAlt} className="text-red-500" />
        <span className="text-red-500 text-sm font-medium">Logout</span>
      </Button>
    </div>
  );

  return (
    <div>
      <Popover
        content={content}
        trigger="click"
        placement="bottomRight"
        open={visible}
        onOpenChange={setVisible}
        overlayClassName="rounded-xl shadow-lg"
      >
        {isLoading ? (
          <Skeleton.Avatar active size={40} shape="circle" />
        ) : (
          <Avatar
            src={imageURL}
            // size={40}
            className={" bg-background text-primary font-bold cursor-pointer"}
          >
            {initials}
          </Avatar>
        )}
        {/* <ProfileAvatar S3Key={user?.logo} name={user?.name} size={40} /> */}
      </Popover>
      <Modal
        open={settingsOpen}
        onCancel={() => setSettingsOpen(false)}
        title="Account Settings"
        footer={null}
        centered
      >
        <div className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
            <Input defaultValue={user?.name || ""} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Change Password</label>
            <Input.Password placeholder="New Password" />
          </div>
          <Button type="primary" className="mt-2 w-full">
            Save Changes
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ProfileMenu;
